import React, {useState} from "react";
import Slider from "react-slick";
import "./HistoryEventsPages.css";
import moment from 'moment';
import 'moment/locale/he';
import HistoryEventsByMonth from './HistoryEventsByMonth';
import HistoryEventsSlider from './HistoryEventsSlider';


class HistoryEventsPages extends React.Component {
    constructor(props) {
        super(props);            
        this.state = {
            allHistoryEvents: props.data,
            currentMonthToDisplay: 1,
            // sortedEvents: props.data.slice(0,props.historyEventsDisplayCounter),
            historyEventsMonthSorted: [],
            historyEventsSliderSorted: [],            
            historyEventsSliderCounter: 0 //MuseumHistoryEventPreMonth.length>4 ? 4 : MuseumHistoryEventPreMonth.length;
            
        };
    }


    componentDidMount() {
        let currentMonthToDisplay = moment().format("M");
        // let historyEventsMonthSorted = this.state.allHistoryEvents.filter(event => {return (moment(event.MuseumHistoryEventDate).format('MM')==(moment().format("MM")))});
        this.updateSelectedMonthEvents(currentMonthToDisplay);
    }

    filterEventsByMonth = (monthToFilter) => {
        return this.state.allHistoryEvents.filter(event => {return (moment(event.MuseumHistoryEventDate).format('M')==(monthToFilter))});
    }

    filterEventsSliderView = (sliderToFilter) => {
        return sliderToFilter.filter(event => {return event.MuseumHistoryEventPreMonth=='כן'});
    }

    sliderViewCalculate = (historyEventsSliderSorted) =>{
        return historyEventsSliderSorted.length >= 4 ? 4 : historyEventsSliderSorted.length;
    }

    setStateFunction(currentMonthToDisplay, historyEventsMonthSorted, historyEventsSliderSorted, historyEventsSliderCounter){
        this.setState({currentMonthToDisplay,
            historyEventsMonthSorted,
            historyEventsSliderSorted,
            historyEventsSliderCounter});
    }

    updateSelectedMonthEvents = (currentMonthToDisplay) =>{
        let historyEventsMonthSorted = this.filterEventsByMonth(currentMonthToDisplay);
        // let historyEventsSliderSorted = historyEventsMonthSorted.filter(event => {return event.MuseumHistoryEventPreMonth=='כן'});
        let historyEventsSliderSorted = this.filterEventsSliderView(historyEventsMonthSorted);

        // let historyEventsSliderCounter = historyEventsSliderSorted.length >= 4 ? 4 : historyEventsSliderSorted.length;
        let historyEventsSliderCounter = this.sliderViewCalculate(historyEventsSliderSorted);
        this.setStateFunction(currentMonthToDisplay, historyEventsMonthSorted,historyEventsSliderSorted, historyEventsSliderCounter);
    }

    dropDownMonthChange = (info) =>{
        let currentMonthToDisplay = info.target.value;
        this.updateSelectedMonthEvents(currentMonthToDisplay);
    }

    handleOnRightClicked = (info) =>{
        let preMonthStr = this.state.currentMonthToDisplay;
        let preMonthInt = parseInt(preMonthStr, 10);
        let rightMonth;
        if(preMonthInt == 1){
            rightMonth = 12;
        }
        else{
            rightMonth = preMonthInt - 1;
        }
        this.updateSelectedMonthEvents(rightMonth.toString());
        //this.setStateFunction(rightMonth.toString(), this.state.historyEventsMonthSorted,  this.state.historyEventsSliderSorted,  this.state.historyEventsSliderCounter);
    }

    handleOnLeftClicked = (info) =>{
        let preMonthStr = this.state.currentMonthToDisplay;
        let preMonthInt = parseInt(preMonthStr, 10);
        let leftMonth;
        if(preMonthInt == 12){
            leftMonth = 1;
        }
        else{
            leftMonth = preMonthInt + 1;
        }
        this.updateSelectedMonthEvents(leftMonth.toString());
        
       // this.setStateFunction(leftMonth.toString(), this.state.historyEventsMonthSorted,  this.state.historyEventsSliderSorted,  this.state.historyEventsSliderCounter);
    }


    render(){
        //let MuseumHistoryEventPreMonth = props.data.filter(event => {return event.MuseumHistoryEventPreMonth=='כן'});
        // let historyEvntsHPCounter = this.state.historyEventsMonthSorted.length > 4 ? 4 : this.state.historyEventsMonthSorted.length;
        
        let monthList=[];
        return (
            <React.Fragment>
                      <div className="dropDownContainer">
                        <div className="dropDownMonthEvents">
                            <i className="fas fa-sort-down"></i>
                            <select id="monthSelectDD"
                                value={this.state.currentMonthToDisplay}
                                className="CalendarSelect1"                    
                                type="select"
                                name="EventDate"
                                onChange={this.dropDownMonthChange}
                                >
                                    <option value="1" key="1" >ינואר</option>
                                    <option value="2" key="2" >פברואר</option>
                                    <option value="3" key="3" >מרץ</option>
                                    <option value="4" key="4" >אפריל</option>
                                    <option value="5" key="5" >מאי</option>
                                    <option value="6" key="6" >יוני</option>
                                    <option value="7" key="7" >יולי</option>
                                    <option value="8" key="8" >אוגוסט</option>
                                    <option value="9" key="9" >ספטמבר</option>
                                    <option value="10" key="10" >אוקטובר</option>
                                    <option value="11" key="11" >נובמבר</option>
                                    <option value="12" key="12" >דצמבר</option>
                            </select>
                        </div>
                        <img className="controlMonthDisplayArrows rightArrowRotate" src="/_layouts/15/images/sites/Museums/MonthEvents/leftArrow.png" onClick={this.handleOnRightClicked}/>

                        <img className="controlMonthDisplayArrows" src="/_layouts/15/images/sites/Museums/MonthEvents/leftArrow.png" onClick={this.handleOnLeftClicked}/>

                        {/* <i className="fas fa-chevron-circle-right" onClick={this.handleOnRightClicked}></i>
                        <i className="fas fa-chevron-circle-left" onClick={this.handleOnLeftClicked}></i> */}
                    </div>
                <div className="historyEventsByMonthPage">
              
                    {this.state.historyEventsMonthSorted.length > 0 ?
                    <div>
                        <div className="sliderHistoryEventsContainer">
                            <HistoryEventsSlider  data={this.state.historyEventsSliderSorted} historyEventsDisplayCounter={this.state.historyEventsSliderCounter} allEventsLink={this.props.allEventsLink} HPorP={2}/>
                        </div>
                        <div className="monthListHistoryEventsContainer">
                        {
                            this.state.historyEventsMonthSorted.map((event, idx) =>  (  
                                <HistoryEventsByMonth key={idx} data={event} />)).sort((a,b) => {            
                                    return a.props.data.MuseumHistoryEventDate < b.props.data.MuseumHistoryEventDate ? -1 : 1;
                        })
                        }
                        </div>
                    </div> :
                    null
                    }
                </div>
            </React.Fragment>
       )
    }
    ;
}

export default HistoryEventsPages;





// class HistoryEventsPages extends React.Component {
//     constructor(props) {
//         super(props);            
//         this.state = {
//             // tablet: window.innerWidth < 769,
//             // mobile: window.innerWidth < 650,
//             allHistoryEvents: props.data,
//             // sortedEvents: props.data.slice(0,props.historyEventsDisplayCounter),
//             historyEventsMonthDisplay: [],
//             historyEventsSliderDisplay: [],            
//             // historyEventsSliderCounter: 4, //MuseumHistoryEventPreMonth.length>4 ? 4 : MuseumHistoryEventPreMonth.length;
//             currentMonthToDisplay:moment().format("MM")
//         };
//     }
//     componentDidMount() {
//         let historyEventsMonthDisplay = this.state.allHistoryEvents.filter(event => {return (moment(event.MuseumHistoryEventDate).format('MM')==(moment().format("MM")))});
//         let historyEventsSliderDisplay = historyEventsMonthDisplay.filter(event => {return event.MuseumHistoryEventPreMonth=='כן'});
//         this.updatee(historyEventsMonthDisplay,historyEventsSliderDisplay)
//     }


//     updatee(historyEventsMonthDisplay, historyEventsSliderDisplay){
//         this.setState({historyEventsMonthDisplay,
//             historyEventsSliderDisplay});
//     }
//     render(){
//         //let MuseumHistoryEventPreMonth = props.data.filter(event => {return event.MuseumHistoryEventPreMonth=='כן'});
//         let historyEvntsSliderCounter = this.state.historyEventsSliderDisplay.length > 4 ? 4 : this.state.historyEventsSliderDisplay.length;
        
//         let monthList=[];
//         return (
//             <React.Fragment>
//                 <div className="historyEventsByMonthPage">
//                     <div className="dropDownMonthEvents">
//                         <i className="fas fa-sort-down"></i>
//                         <select id="monthSelectDD"                    
//                             className="CalendarSelect1"                    
//                             type="select"
//                             name="EventDate"
//                             // onChange={this.state.currentMonthToDisplay)}>
//                             >
//                                 <option value="1" key="1" >ינואר</option>
//                                 <option value="2" key="2" >פברואר</option>
//                                 <option value="3" key="3" >מרץ</option>
//                                 <option value="4" key="4" >אפריל</option>
//                                 <option value="5" key="5" >מאי</option>
//                                 <option value="6" key="6" >יוני</option>
//                                 <option value="7" key="7" >יולי</option>
//                                 <option value="8" key="8" >אוגוסט</option>
//                                 <option value="9" key="9" >ספטמבר</option>
//                                 <option value="10" key="10" >אוקטובר</option>
//                                 <option value="11" key="11" >נובמבר</option>
//                                 <option value="12" key="12" >דצמבר</option>
//                         </select>
//                     </div>
//                     <div className="sliderHistoryEventsContainer">
//                         <HistoryEventsSlider allEventsLink={this.props.allEventsLink} data={this.state.allHistoryEvents} historyEventsDisplayCounter={historyEvntsSliderCounter}/>
//                     </div>
//                     <div className="monthListHistoryEventsContainer">
//                     {

//                         this.state.historyEventsMonthDisplay.map((event, idx) =>  (  
//                             <HistoryEventsByMonth key={idx} data={event} />)).sort((a,b) => {            
//                                 return a.props.data.MuseumHistoryEventDate < b.props.data.MuseumHistoryEventDate ? -1 : 1;
//                     })
//                     }
//                     </div>
//                 </div>
//             </React.Fragment>
//        )
//     }
//     ;
// }

// export default HistoryEventsPages;
